module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/perry-ellis-4b96a41699d2e56f4ffa42892fb6f9b6.png";